<template lang="pug">
  v-layout(align-start)
    v-col(cols='12')
      v-card(color='white')
        v-card-subtitle.title(style='color: black') Información del Producto
        v-card-text
          v-row(dense)
            v-flex(xs12 sm12 md12 style='display: flex;justify-content: center;')
              v-col(cols='12' sm='12' md='4')
                v-text-field(@keyup.enter='enterClicked' id="codNom" outlined dense v-model='editedItem.nombre' placeholder='Código')
          v-row(dense)
            v-flex(xs12 sm12 md12 style='display: flex;justify-content: center;')
              v-col(cols='12' sm='12' md='12')
                v-data-table.table(:headers='headPro' style="border: 1px solid #EEEEEE;" hide-default-footer :items='productos')
                  template(v-slot:no-data)
                    h1 Inserte un código
</template>

<script>
import Api from '@/services/methods';
export default {

  data: () => ({
    productos: [],
    headPro: [
      { text: 'Codigo', value: 'nombre', align: 'left' },
      { text: 'Descripcion', value: 'descripcion', align: 'center' },
      { text: 'Precio', value: 'precioBs', align: 'center' },
      { text: 'Existencia', value: 'stock', align: 'center' },
      { text: 'Portafolio', value: 'codPortafolio', align: 'center' }
    ],
    editedItem: {
      nombre: ''
    },
  }),

  watch: {
    'editedItem.nombre': function (val) {
      this.productos = []
    },
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.permisosRuta = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Producto')
    },

    enterClicked () {
      Api.post('producto/consultaPro', { nombre: this.editedItem.nombre
      })
      .then(response => {
        if (response.data.status === 'denied') {
          this.$swal({
            icon: 'error',
            title: 'Error en la busqueda!',
            text: response.data.message
          })
        } else {
          this.productos = [{
            nombre: response.data[0][0].nombre,
            descripcion: response.data[0][0].descripcion,
            precioBs: response.data[0][0].precioBs,
            stock: response.data[0].stock,
            codPortafolio: response.data[0][0].codPortafolio.descripcion
          }]
        }
      })
      .catch(error => {
        if (error.response) {
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'Por favor, verifique los datos e intente de nuevo'
          })
        } else if (error.request) {
          this.$swal({
            icon: 'error',
            title: 'Error de red',
            text: 'Por favor verique su conexion de internet'
          })
        } else {
          console.log('Error', error.message)
        }
      })
    },

    close () {
    },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    }
  }
}
</script>

<style lang='scss'>
@import '~@/assets/scss/consultaPro.scss';
</style>
